import React from 'react';
import { GetStartedButton } from '../common/GetStartedButton';

const AUDIENCES = [
  {
    title: '4-Year College & Summer League Coaches',
    tagline: 'Find the right JUCO talent. Make smarter recruiting decisions.',
    points: [
      'NCAA, NAIA, and 4-year programs looking for proven players who can contribute immediately.',
      'Summer collegiate coaching staffs managing constant roster turnover and needing to quickly identify replacements who can contribute.',
      'Coaches who need reliable data to evaluate performance, compare players, and narrow their recruiting boards.',
      'Programs looking beyond the transfer portal to discover overlooked talent that fits their needs.',
    ],
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-4.35-4.35M10.5 18a7.5 7.5 0 100-15 7.5 7.5 0 000 15z" />
    ),
  },
  {
    title: 'JUCO Baseball Players',
    tagline: 'Get seen by coaches who can take you to the next level.',
    points: [
      { lead: "Get beyond your program's recruiting pipeline", text: "and connect with four-year programs outside your coach's established network." },
      { lead: 'Get discovered on your own merits', text: 'by coaches searching for players who fit their roster needs.' },
      { lead: 'Showcase your production', text: 'with comprehensive statistics, advanced metrics, and performance data.' },
      { lead: 'Take control of your next step', text: 'instead of relying solely on your coaches to find you an opportunity.' },
    ],
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 15l-3.5 2 1-4-3-2.7 4-.3L12 6l1.5 4 4 .3-3 2.7 1 4z M12 21a9 9 0 100-18 9 9 0 000 18z" />
    ),
  },
];

const CheckIcon = () => (
  <svg className="w-4 h-4 text-jp-accent-ink mt-0.5 flex-shrink-0" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
  </svg>
);

export const WhoItsForBox = () => {
  return (
    <div className="w-full flex-1 min-w-0 flex flex-col">
      {/* Header */}
      <div className="mb-5">
        <h2 className="text-2xl sm:text-3xl font-extrabold text-jp-ink">
          Who It's <span className="text-jp-accent">For</span>
        </h2>
      </div>

      <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-4 bg-jp-card rounded-2xl border border-jp-outline/70 shadow-sm p-4">
        {AUDIENCES.map((audience) => (
          <div
            key={audience.title}
            className="flex flex-col rounded-xl p-5 bg-jp-section border border-jp-outline/50"
          >
            <div className="w-11 h-11 rounded-full bg-jp-accent/15 flex items-center justify-center mb-4">
              <svg className="w-5 h-5 text-jp-accent-ink" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                {audience.icon}
              </svg>
            </div>
            <h3 className="text-xl font-bold text-jp-ink mb-2">{audience.title}</h3>
            <p className="text-jp-ink/80 text-sm leading-relaxed mb-5">{audience.tagline}</p>
            <ul className="space-y-2.5">
              {/* A point is plain text, or { lead, text } with a bold lead-in */}
              {audience.points.map((point) => (
                <li key={point.lead || point} className="flex gap-2 text-jp-muted text-sm">
                  <CheckIcon />
                  {point.lead ? (
                    <span>
                      <strong className="font-semibold text-jp-ink">{point.lead}</strong> {point.text}
                    </span>
                  ) : (
                    <span>{point}</span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="mt-5">
        <GetStartedButton>GET STARTED</GetStartedButton>
      </div>
    </div>
  );
};

export default WhoItsForBox;
